import type { PropsWithChildren } from "react";
import React, { memo } from "react";
import type { NavigationVariants } from "./Navigation.styles";
import NavigationVariant from "./Navigation.styles";

export type NavigationVariantsType = keyof typeof NavigationVariants;

export type NavigationProps = {
    variant: NavigationVariantsType;
};

const Navigation: React.FC<PropsWithChildren<NavigationProps>> = (props) => {
    const { variant, children } = props;
    return <NavigationVariant variant={variant}>{children}</NavigationVariant>;
};

export default memo(Navigation);
